"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Fields_1 = require("./../Fields");
var Loader_1 = require("./../Loader");
var PaymentMethodLayout_1 = require("./../PaymentMethodLayout");
var Translate_1 = require("./../Translate");
var s = require("./CreditCard.scss");
var CreditCard = (function (_super) {
    __extends(CreditCard, _super);
    function CreditCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.creditCardNode = null;
        _this.state = {
            error: false,
            loading: true,
        };
        _this.isSpinnerVisible = function () { return _this.state.loading && !_this.state.error; };
        _this.handleInstallmentsSelect = function (selectedOption) {
            if (_this.props.setInstallments) {
                _this.props.setInstallments('creditCard', String(selectedOption.id));
            }
        };
        return _this;
    }
    CreditCard.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.renderPaymentMethod('creditCard', this.creditCardNode)];
                    case 1:
                        _a.sent();
                        this.setState({ error: false, loading: false });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        this.setState({ error: true, loading: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CreditCard.prototype.renderInstallmentsIfSupported = function () {
        var installments = this.props.info.installments;
        if (!installments) {
            return null;
        }
        return (React.createElement("div", { className: s.installmentsWrap },
            React.createElement(Fields_1.Installments, { installments: installments, onInstallmentsSelect: this.handleInstallmentsSelect })));
    };
    CreditCard.prototype.renderSpinner = function () {
        if (!this.isSpinnerVisible()) {
            return null;
        }
        return React.createElement(Loader_1.default, null);
    };
    CreditCard.prototype.renderError = function () {
        if (!this.state.error) {
            return null;
        }
        return (React.createElement("div", { key: "error", "data-hook": "cc-error", className: s.creditCardPayment, style: { minHeight: 'auto' } },
            React.createElement(Translate_1.default, { forKey: "cc.load.error" })));
    };
    CreditCard.prototype.renderCreditCardForm = function () {
        var _this = this;
        if (this.state.error) {
            return null;
        }
        return (React.createElement("div", { className: s.creditCardPayment },
            React.createElement("div", { key: "form", "data-hook": "cc-form", id: "cashier-payments-method-creditCard-iframe-parent", ref: function (node) { return _this.creditCardNode = node; } }),
            this.renderInstallmentsIfSupported()));
    };
    CreditCard.prototype.render = function () {
        return (React.createElement(PaymentMethodLayout_1.default, { noPadding: !this.state.error, dataHook: "cashier-payments-method-creditCard" },
            this.renderCreditCardForm(),
            this.renderError(),
            this.renderSpinner()));
    };
    CreditCard.defaultProps = {
        info: {},
    };
    return CreditCard;
}(React.Component));
exports.default = CreditCard;
//# sourceMappingURL=CreditCard.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/CreditCard/CreditCard.js
// module id = 152
// module chunks = 0 1